import { GeoJson } from './GeoJson';

export const SupportedChemicals = {
  Delaro365sc: {
    id: '5395aba6-c63d-4825-9747-2fce23f2edcd ',
    name: 'Delaro 325 SC',
  },
  DelaroComplete: {
    id: 'f9f96b06-5a00-417c-ad5c-82822659f3fe',
    name: 'Delaro Complete',
  },
} as const;

export type ChemicalType = keyof typeof SupportedChemicals;

export type ChemicalMethods = typeof SupportedChemicals[ChemicalType];

export type FloatMeasurement = {
  unit: string;
  value: number;
};

export enum Role {
  CHAMPION = 'CHAMPION',
  CHALLENGER = 'CHALLENGER',
}

export enum GeoJSONGeometryTypes {
  GEOMETRY_COLLECTION = 'GeometryCollection',
  LINE_STRING = 'LineString',
  POINT = 'Point',
  POLYGON = 'Polygon',
  MULTI_LINE_STRING = 'MultiLineString',
  MULTI_POINT = 'MultiPoint',
  MULTI_POLYGON = 'MultiPolygon',
}

export type GeoJSONGeometry = {
  type: GeoJSONGeometryTypes;
  bbox?: number[];
};

export type PointGeoJSONGeometry = GeoJSONGeometry & {
  coordinates: number[];
};

export type TrialPlacementComponent = {
  name: string;
  treatments: {
    p: string;
    u: string;
    v: string;
  }[];
  area: {
    v: number;
    u: string;
  };
  pointCoordinates: number[];
  geometry: GeoJson;
};

export interface TrialRegion {
  experimentalUnits: {
    champion: TrialPlacementComponent;
    challengers: TrialPlacementComponent[];
  }[];
}
